import { render } from "./JobsView.vue?vue&type=template&id=bfddd6e0&scoped=true"
import script from "./JobsView.vue?vue&type=script&lang=js"
export * from "./JobsView.vue?vue&type=script&lang=js"

import "./JobsView.vue?vue&type=style&index=0&id=bfddd6e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfddd6e0"]])

export default __exports__